import { SVGProps } from "react";
import { AlertCircle } from "react-feather";
import { useTranslation } from "../../utils/hooks/useTranslation";

export const DivergentOpeninghoursIcon = (props: SVGProps<SVGSVGElement>) => {
  const { t } = useTranslation();
  return <AlertCircle size="1em" aria-label={t("Avvik")} {...props} />;
};
